import { makeStyles, css } from '@conexasaude/conexa-hero'

const useStyles = makeStyles({
  title: () => css`
    margin-bottom: 8px;
  `,
  tipsList: () => css`
    li {
      margin-bottom: 8px;
    }
  `,
})

export { useStyles }
